import type { TranslationStrings } from "../types";

export const en: TranslationStrings = {
  "All set!": "All set!",
  "Your World ID is now connected": "Your World ID is now connected",
  "Already verified": "Already verified",
  "You've already verified for this action.":
    "You've already verified for this action.",
  "Something went wrong": "Something went wrong",
  "Request cancelled": "Request cancelled",
  "You've cancelled the request in World App.":
    "You've cancelled the request in World App.",
  "Verification unavailable": "Verification unavailable",
  "This verification request couldn't be completed. Please contact the website owner.":
    "This verification request couldn't be completed. Please contact the website owner.",
  "Connection lost": "Connection lost",
  "Please check your connection and try again.":
    "Please check your connection and try again.",
  "Verification declined": "Verification declined",
  "Failed to verify your credential proof. Please contact the website owner.":
    "Failed to verify your credential proof. Please contact the website owner.",
  "We couldn't complete your request. Please try again.":
    "We couldn't complete your request. Please try again.",
  "Try Again": "Try Again",
  Close: "Close",
  "Open World App": "Open World App",
  "QR Code copied": "QR Code copied",
  "Connect your World ID": "Connect your World ID",
  "Use phone camera to scan the QR code":
    "Use phone camera to scan the QR code",
  "Connecting...": "Connecting...",
  "Please continue in app": "Please continue in app",
  "Transmitting verification to host app. Please wait...":
    "Transmitting verification to host app. Please wait...",
  "You will be redirected to the app, please return to this page once you're done":
    "You will be redirected to the app, please return to this page once you're done",
  "Terms & Privacy": "Terms & Privacy",
};
